import { useEffect, useState } from 'react';
import { Button, Col, Collapse, DatePicker, Form, Input, Row, Select,Modal,Pagination,Spin } from 'antd';
import { AiOutlinePrinter, AiOutlineSearch, AiOutlineSync,AiOutlineFile,AiOutlineRight,AiOutlineDown} from 'react-icons/ai';
import MessageCommon from '../../enum/Message';
import { Label } from 'reactstrap';
import secureLocalStorage  from  "react-secure-storage";
import {CartonStatus, ExportType } from '../../enum';
import { CartonList ,Parameter ,Item, User,Element} from '../../models'
import { Helper, InitHelper,StickyHelper } from '../../helpers';
import { StorageCartonService ,HrWebService, FileManageService,PropertyService} from '../../services';
import dayjs from 'dayjs'
import { EmployeeAutoComplete } from '../../autocomplete/EmployeeAutoComplete'
import { ProjectAutoComplete } from '../../autocomplete/ProjectAutoComplete'
import StorageCartonRequestDetail from '../StorageCarton/StorageCartonRequestDetail'
import CartonDetail from '../Share/CartonDetail';
import { apiRequest } from "../../configurations/authConfig";
import { useMsal } from "@azure/msal-react";

interface AppState {
  currentPage:number
  perpage:number
  total: number
  items:CartonList[]
  isLoading:boolean
}

interface StorageCarton{
  requestNo:string
  cartonNo:string
}

const MyDocument = () => {
    const stickyHelper = new StickyHelper("mydoc",50,400)
    const stickyElement:Element = stickyHelper.getElement()
    stickyHelper.setMinHight(900)
    const returnIfElse = (flag: any, obj1: any, obj2: any) => {
        return flag ? obj1 : obj2;
    }
    
    

    const { instance, accounts } = useMsal();
    const userStore = secureLocalStorage.getItem('user')
    const user:User = userStore ? JSON.parse(userStore.toString()): null
    const pageSizeOptions = user.systemConfig.tablePageSize
    const [dataForm] = Form.useForm();
    const [isModalCartonOpen, setIsModalCartonOpen] = useState(false);
    const [isModalCartonDetailOpen, setIsModalCartonDetailOpen] = useState(false);
    const [saveParameter,setSaveParameter] = useState<Parameter>(InitHelper.InitialParameter)
    const [recordNo, setRecordNo] = useState(0);
    const [modal, contextHolder] = Modal.useModal();
    const [appState,setAppState] = useState<AppState>({
      currentPage : 1,
      total : 0,
      perpage: 10,
      items: [],
      isLoading : true
    })
    const [activeKey,setActiveKey] = useState('0')
    const [requesters, setRequesters] = useState<Item[]>([])
    const [owners, setOwners] = useState<Item[]>([])
    const [requestStartDate, setRequestStartDate] = useState<Date|null>(null);
    const [requestEndDate, setRequestEndDate] =  useState<Date|null>(null);
    const [storageCarton,setStorageCarton] = useState<StorageCarton>({requestNo: "",cartonNo: ""})
    const [documentStartYear, setDocumentStartYear] = useState<number|null|undefined>(undefined);
    const [documentEndYear, setDocumentEndYear] = useState<number|null|undefined>(undefined);
    const [isPrint,setIsprint] = useState(true)
    const [projects, setProjects] = useState<Item[]>([])
    const [isLoadingPrint,setIsLoadingPrint] = useState(false)
    const [isDesOpen,setIsDesOpen] = useState(false)
    const [desc,setDesc] = useState("")
    const [clientHeight,setClientHeight] = useState(0)

    const onSetClientHeight = () => {
    
      setTimeout(() => {
        stickyHelper.updatePosition()
        window.scrollTo(0,0)
        let element = document.getElementById(stickyElement.container) as HTMLInputElement
        if(element){
          let value = element.clientHeight
          setClientHeight(value)
        }
      }, 100);
    
    }

    useEffect(() => {
      let parameter = Object.assign({},InitHelper.InitialParameter())
      parameter.cartonStatusIds = [ CartonStatus.Storage ]
       
   
        getData(1,appState.perpage,parameter).then(() => {
            stickyHelper.updatePosition()
  
        })

        stickyHelper.removeEvent()
        stickyHelper.addEvent()

        window.addEventListener("resize", () => { 
            onSetClientHeight()
        });
    }, [])
  
    const onFinish = (values: any) => {
    };
  
  
    const layout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
   
    const showModalCarton = async (item:CartonList) => {
        setRecordNo(item.recordNo)
        setIsModalCartonOpen(true);
    };
    
    const handleCancelCarton = () => {
        setIsModalCartonOpen(false);
    
    };

    const showModalCartonDetailOpen = async (_recordNo: number, _requestNo: string, _cartonNo:string) => {
        let _storageCarton:StorageCarton = {
            requestNo: _requestNo,
            cartonNo: _cartonNo
        }
        setRecordNo(_recordNo)
        setStorageCarton(_storageCarton)
        setIsModalCartonDetailOpen(true);
    }

    const handleCartonDetailCancel = () => {
        setIsModalCartonDetailOpen(false);
      }
      
    const getData = async (currentPage: number,perpage: number,_parameter:Parameter | null = null) => {
      let _state:AppState = Object.assign({},appState)
         _state.isLoading = true
         setAppState(_state)
      let parameter = Object.assign({},saveParameter)
      if(_parameter !== null){
          parameter = Object.assign({},_parameter);
      }
      
        parameter.page = currentPage
        parameter.limit = perpage
        
        parameter.requester = user.employeeId
        parameter.requesterOrgUnit = user.orgUnit
        parameter.employeeLevel = user.level
         parameter.userConfidential = user.employeeId
      parameter.statusIds = [CartonStatus.Done]
      
    
        let token = await getToken()
        let result = await new StorageCartonService(token).SearchMyDoc(parameter)
        
        if(result && result.success)
        {
            let state = Object.assign({},appState)
                state.total = result.data.total
                state.perpage = perpage
                state.currentPage = currentPage
                state.items = result.data.items
                state.isLoading = false
                state.perpage = perpage
            if(result.data.total>0){
              setIsprint(false)
            }else{
              setIsprint(true)
            }
            setTimeout(() => {
                setSaveParameter(parameter)
                setAppState(state)
                setTimeout(() => {
                  onSetClientHeight()
                }, 100);
            }, 500);
        }
        else{
          
          let state = Object.assign({},appState)
          state.isLoading = false
          setAppState(state)
        }
        
    }
  
    const searchData = async () => {
      
      let field = dataForm.getFieldsValue()
      
      let parameter = InitHelper.InitialParameter();
          parameter.page =1
          parameter.limit = appState.perpage
          parameter.cartonStatusIds = [
            CartonStatus.Storage,
            CartonStatus.Collect,
            CartonStatus.Return,
            CartonStatus.Remove,
            CartonStatus.Destruction
        ]
        parameter.condition = "and"
        parameter.documentStartYear = documentStartYear
        parameter.documentEndYear = documentEndYear
        parameter.requestStartDate = requestStartDate
        parameter.requestEndDate = requestEndDate
      
      if(field.cartonStatusIds){
        parameter.cartonStatusIds = field.cartonStatusIds
      }

      if(field.description){
        parameter.description = field.description
      }

      if(requesters.length > 0){
        parameter.requesters = requesters.map(item => item.key)
      }

      if(owners.length > 0){
        parameter.owners = owners.map(item => item.key)
      }

      if(projects.length > 0){
        parameter.projectIds = projects.map(item => parseInt(item.key))
      }

      if(field.requestNo){
        parameter.requestNoList = field.requestNo.trim().split(",")
      }

      if(field.confidentialLevel !== undefined){
        parameter.confidentialLevel = field.confidentialLevel
      }
  
      let elementStart = document.getElementById('cartonNoStart') as HTMLInputElement
      let elementEnd = document.getElementById('cartonNoEnd') as HTMLInputElement
      let cartonNoStart = ""
      let cartonNoEnd = ""
      if(elementStart){
        cartonNoStart = elementStart.value
      }
      if(elementEnd){
        cartonNoEnd = elementEnd.value
      }
  
      if(cartonNoStart && cartonNoEnd){
        parameter.cartonNo = cartonNoStart + '&' + cartonNoEnd
      }
  
      if(field.cartonNoList){
        parameter.cartonNo = field.cartonNoList
      }
  
      if(field.cartonNo){
        parameter.cartonNo = field.cartonNo
      }
  
      
      getData(1,appState.perpage,parameter)
      
   }
   
   const reset = () => {
    let elementStart = document.getElementById('cartonNoStart') as HTMLInputElement
    let elementEnd = document.getElementById('cartonNoEnd') as HTMLInputElement
    elementStart.value = ""
    elementEnd.value = ""
     dataForm.resetFields()
     setRequesters([])
     setOwners([])
     setProjects([])
     setRequestStartDate(null)
     setRequestEndDate(null)
     let parameter = Object.assign({},InitHelper.InitialParameter())
     
     parameter.cartonStatusIds = [
        CartonStatus.Storage
      ]
     getData(1,appState.perpage,parameter)
  }

   const onSearchEmployee = async(key:string) => {
     
    let token = await getToken()
    let result = await new HrWebService(token).SearchEmployee(key)
    if(result && result.success)
    {
        let _orgUnit = user.orgUnit
            if(user.orgUnit.indexOf("/") > -1) {
                _orgUnit = user.orgUnit.split("/")[0]
            }
            return result.data.filter(x => x.orgUnit.trim().indexOf(_orgUnit.trim()) > -1)
    }
    else{
      console.log(result?.message)
      return []
    }
  }

  const onSearchProject = async(key:string) => {
     
    let token = await getToken()
    let result = await new PropertyService(token).SearchProject(key)
    if(result && result.success)
    {
        return result.data
    }
    else{
      console.log(result?.message)
      return []
    }
  }

    const getToken = async () => {
        const acc = accounts && accounts.length ? accounts[0] : null;
        apiRequest.scopes[0] = "api://" + secureLocalStorage.getItem('clientId') + "/read_user_profile"
        if (acc) {
            const { accessToken: token } = await instance.acquireTokenSilent({
                account: acc,
                scopes: apiRequest.scopes
            });
            return token;
        }
        return ""
    }

  
    const onRequestStartDateChange = (date: any) => {
      setRequestStartDate(date);
    }
  
    const onRequestEndDateChange = (date: any) => {
      setRequestEndDate(date)
    }
  
    const onPageChange = (page:number,perpage:number) => {
        if(perpage !== appState.perpage){
            getData(1,perpage)
        }
        else{
            getData(page,appState.perpage)
        }
    }
  
  const onRequesterSelect = (item:any) => {
    setRequesters(item)
    stickyHelper.updatePosition()
  }
  
  const onOwnerSelect = (item:any) => {
    setOwners(item)
    stickyHelper.updatePosition()
  }
  
  
  
  const onDocumentStartYearChange = (value: any) => {
    let year = parseInt(dayjs(value).format('YYYY'))
    setDocumentStartYear(year)
  }
  
  const onDocumentEndYearChange = (value: any) => {
    let year = parseInt(dayjs(value).format('YYYY'))
    setDocumentEndYear(year)
  }
  const onFinishPrint = async () => {
    setIsLoadingPrint(true)

    let token = await getToken()
    if(!saveParameter)return
    try{

      await new FileManageService(token).DownloadReport(saveParameter,ExportType.ORG_UNIT_DOCUMENT);
    }catch(error){
      console.log("🚀 ~ file: MyDocument.tsx:297 ~ onFinishPrint ~ error:", error)
      
    }finally{
      setIsLoadingPrint(false)

    }
  }

  const onProjectSelect = (item:any) => {
    setProjects(item)
}



  return (

    <div>
       <div id={stickyElement.search} className='carton-search-top' onClick={ () => stickyHelper.setCollapse()}>
          <span id="arrow-right" className='display-inline'>
              <AiOutlineRight className='carton-search-top-img'/>
          </span>
          <span id="arrow-down" className='display-none'>
            <AiOutlineDown  className='carton-search-top-img'/>
          </span>
          <span>Carton Search</span>
            
        </div>
        <div id={stickyElement.openSearch} className='carton-search-bottom'>
        <Form
            {...layout}
            form={dataForm}
            name="nest-messages"
            onFinish={onFinish}
            labelAlign="left"
            colon={false}
            labelWrap={true}
          >

            <Row>
              <Col md={11} >
                  <Form.Item label="Carton No:(Range)" >
                      <table className='w100c'>
                        <tbody>
                        <tr>
                          <td>
                            <input id="cartonNoStart" className='form-control form-control-sm' placeholder='ex. 03PCS001'/>
                          </td>
                          <td>
                            <Label className='margin-left-10 margin-right-5'>To</Label>
                          </td>
                          <td>
                            <input id="cartonNoEnd" className='form-control form-control-sm' placeholder='ex. 03PCS001'/>
                        
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </Form.Item>
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
                  <Form.Item name="requestNo" label="Request No."  >
                    <Input placeholder="ex. B230001,B230002,B230003" />
                  </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={11} >
                  <Form.Item name="cartonNoList" label="Carton No (Multiple)" >
                        <Input.TextArea rows={5} placeholder='ex. 03PCS001,03PCS002,03PCS003'/>
                  </Form.Item>
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
                <Form.Item name="documentYear" label="Document Year">
                  <table className='w100c'>
                    <tbody>
                    <tr>
                      <td>
                        <DatePicker 
                          placeholder={MessageCommon.TitleDate} 
                          picker='year' className='w100c' 
                          onChange={onDocumentStartYearChange}
                        />
                      </td>
                      <td>
                        <Label className='margin-left10 margin-right10 vertical-align-top'>To</Label>
                      </td>
                      <td>
                        <DatePicker 
                          placeholder={MessageCommon.TitleDate} 
                          picker='year' 
                          className='w100c'
                          onChange={onDocumentEndYearChange}
                        />
                      </td>
                    </tr>
                    </tbody>
                  </table>


                </Form.Item>
                <Form.Item name="requestDate" label="Request Date">
                      <table className='w100c'>
                        <tbody>
                        <tr>
                          <td>
                            <DatePicker placeholder={MessageCommon.TitleDate} className='date-picker-full' format={"DD MMM YYYY"} onChange={onRequestStartDateChange}/>
                          </td>
                          <td>
                            <Label className='margin-left-10 margin-right-10'>To</Label>
                          </td>
                          <td>
                            <DatePicker placeholder={MessageCommon.TitleDate} className='date-picker-full' format={"DD MMM YYYY"} onChange={onRequestEndDateChange}/>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                </Form.Item>
                    <Form.Item name="requester" label="Requester"  >
                        <EmployeeAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={requesters ? requesters : []}
                            onChange={item => onRequesterSelect(item)}
                            service={onSearchEmployee}
                            minimumTextLength={3}
                        />
                    </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={11} >
                <Form.Item name="cartonNo" label="Carton No" >
                        <Input placeholder='ex. 03PCS001'/>
                </Form.Item>
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
                    <Form.Item name="owner" label="Owner"  >
                        <EmployeeAutoComplete
                            key={Helper.Uniqid()}
                            placeholder='Search by Name'
                            selectedItems={owners ? owners : []}
                            onChange={item => onOwnerSelect(item)}
                            service={onSearchEmployee}
                            minimumTextLength={3}
                        />
                    </Form.Item>
              </Col>
            </Row>
      
            <Row>
              <Col md={11} >
              
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
               
              </Col>
            </Row>
            <Row>
              <Col md={11} >
                <Form.Item name="description" label="Description"  >
                  <Input placeholder={MessageCommon.TitleInput} />
                </Form.Item>
              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
                  <Form.Item name="projectName" label="Project Name"  >
                    <ProjectAutoComplete
                                          key={Helper.Uniqid()}
                                          placeholder='Search by Name'
                                          selectedItems={returnIfElse(projects, projects, [] ) }
                                          onChange={item => onProjectSelect(item)}
                                          service={onSearchProject}
                                          minimumTextLength={2}
                                      />
                  </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col md={11} >
                <Form.Item name="confidentialLevel" label="Confidentiality Level" >
                  <Select placeholder={MessageCommon.TitleSelect}
                    defaultValue={-1}
                    options={[
                        { value: -1, label: 'All' },
                        { value: 0, label: 'Non-Confidential' },
                        { value: 1, label: 'Confidential' }
                    ]} />
                </Form.Item>

              </Col>
              <Col md={2} >
              </Col>
              <Col md={11} >
                <Form.Item name="cartonStatusIds" label="Carton Status"  >
                  <Select placeholder={MessageCommon.TitleSelect}
                    mode="multiple"
                    allowClear
                    options={[
                      { value: CartonStatus.Storage, label: 'Storage' },
                        { value: CartonStatus.Collect, label: 'Collect' },
                        { value: CartonStatus.Return, label: 'Return' },
                        { value: CartonStatus.Remove, label: 'Remove' },
                      { value: CartonStatus.Destruction, label: 'Destroy' }
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>


          </Form>
          <div className='text-center'>
            <Button type="default" className='mr-btn'  onClick={reset}>
              <AiOutlineSync className='icn-btn' /> Reset
            </Button>
            <Button type="primary"  onClick={searchData}>
              <AiOutlineSearch className='icn-btn' /> Search
            </Button>


          </div>
        </div>

        <div id={stickyElement.space} className='sticky-space sticky-bg-white display-none'></div>
        <div id={stickyElement.space2} className='sticky-space2 sticky-bg-grey'></div>
      <div id={stickyElement.result} className='sticky-data-top sticky-border-top sticky-border-left sticky-border-right'>
          
              <div>
                <Button type="primary" htmlType="button" className='mr-btn' disabled={isPrint} onClick={()=>onFinishPrint()} >
                  <AiOutlinePrinter className='icn-btn' />Print
                </Button>
                
             
                </div>
           
              <div className='search-result'>Search found { appState.total } record(s).</div>
        </div>
      <div id={stickyElement.dataFixed} className='sticky-data-bottom sticky-border-bottom sticky-border-left sticky-border-right'>
        { appState.isLoading ?
          <Spin tip="Loading" size="large">
            <div className="content" />
          </Spin>
          :
          <>
          
            <div id={stickyElement.container} >
              <table className='idoc-table'>
                <thead id={stickyElement.data}>
                  <tr>
                    {/* <th className="thfix1 text-center w50">No.</th> */}
                    <th className="s-th thfix1">Request No.</th>
                    <th className="s-th">Carton No.</th>
                    <th className="text-left w400">Description</th>
                    <th className="s-th">Project</th>
                    <th className="s-th">Requester</th>
                    <th className="s-th">Owner</th>
                    <th className="s-th">Carton Status</th>
                    <th className="s-th">Org Unit.</th>
                    <th className="s-th">File</th>
                  </tr>
                </thead>
                <tbody >
                  { appState.items.map((item:CartonList,index:number) => (
                    <tr>
                      {/* <td>
                         {((appState.currentPage-1) * appState.perpage + index + 1)}
                      </td> */}
                      <td className="s-td tdfix1 text-center">
                       
                        <a className='a-table' onClick={() => showModalCarton(item)}>{item.requestNo}</a>
                           
                      </td>
                      <td className="s-td text-center">
                        
                        <a className={ item.cartonStatusId === CartonStatus.Remove || item.cartonStatusId === CartonStatus.Destruction ? 'a-table c-red' : 'a-table'}  onClick={() => showModalCartonDetailOpen(item.storageRecordNo, item.requestNo, item.cartonNo)}>{item.cartonNo}</a>
                             
                      </td>
                      <td className="text-left break-word w400">
                        
                        {item.description }
                        
                        
                    </td>
                      <td className="s-td text-center">{ item.projectName}</td>
                      <td className="s-td text-center">{ item.requesterName}</td>
                      <td className="s-td text-center">{ item.ownerName }</td>
                      <td className="s-td text-center">
                        { item.cartonStatusId === CartonStatus.Destruction ? 'Destroy' : 
                          item.cartonStatusId === CartonStatus.Extend ? 'Extend' : 
                          item.cartonStatus
                        }
                      
                      
                      </td>
                      <td className="s-td text-center">{ item.orgUnit }</td>
                      <td className="s-td text-center">
                              {returnIfElse(item.confidentialLevel === 1 && (item.requester === user.employeeId || item.owner === user.employeeId),
                                  <a onClick={() => showModalCartonDetailOpen(item.storageRecordNo, item.requestNo, item.cartonNo)}>
                                      <AiOutlineFile className='icon-table' />
                                  </a>,
                                  <></>)
                        }
                              {returnIfElse(item.confidentialLevel === 0,
                                  <a onClick={() => showModalCartonDetailOpen(item.storageRecordNo, item.requestNo, item.cartonNo)}>
                                      <AiOutlineFile className='icon-table' />
                                  </a>,
                                  <></>) 
                        }
                        </td>
                    </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
            <div className='margin-top-10 text-right'>
            { appState.total > 0 ?
              <Pagination 
                key={Helper.Uniqid()}
                current={appState.currentPage} 
                pageSize={appState.perpage}
                total={appState.total} 
                onChange={onPageChange} 
                pageSizeOptions={pageSizeOptions}
                showSizeChanger={true}
              />:<></>
            }
            </div>
          </>
        }
      </div>
       
      <input type="hidden" id={stickyElement.clientHight} defaultValue={clientHeight}/>
    

      <Modal title="" open={isDesOpen} footer={''} width={1200} onCancel={() => setIsDesOpen(false)}>
          <div>
            {desc}
          </div>
            
      </Modal>

      <Modal title="" open={isModalCartonDetailOpen} footer={''} width={1200} onCancel={handleCartonDetailCancel}>
            <CartonDetail key={Helper.Uniqid()} requestNo={storageCarton.requestNo} box={storageCarton.cartonNo} />
            
      </Modal>

        <Modal title="Request Detail" open={isModalCartonOpen} footer={''} width={1550} onCancel={handleCancelCarton}>
            <StorageCartonRequestDetail 
              key={Helper.Uniqid()}
              recordNo={recordNo}  
                  approveLevel={0} cartonNumber={""}
            />
          </Modal>
          {modal ? <span></span> : <></>}
        {contextHolder}
        
    </div>
  );

}

export default MyDocument
